import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["container", "assignment"]

  connect() {
    this.assignmentIndex = this.assignmentTargets.length
  }

  addAssignment() {
    const newAssignmentHtml = this.buildAssignmentHtml(this.assignmentIndex)
    this.containerTarget.insertAdjacentHTML('beforeend', newAssignmentHtml)
    this.assignmentIndex++
  }

  removeAssignment(event) {
    const assignmentDiv = event.target.closest('[data-target="key-account-assignments.assignment"]')
    const destroyField = assignmentDiv.querySelector('input[name*="_destroy"]')
    
    if (destroyField) {
      destroyField.value = '1'
      assignmentDiv.style.display = 'none'
    } else {
      // For new assignments that haven't been saved yet, just remove the element
      assignmentDiv.remove()
    }
  }

  buildAssignmentHtml(index) {
    const accountTypes = [
      ['Accounts payable', 'accounts_payable'],
      ['Fund balance unassigned', 'fund_balance_unassigned'], 
      ['Transfers in', 'transfers_in'],
      ['Transfers out', 'transfers_out']
    ]

    const accountOptions = window.glAccountOptions || []
    
    const accountTypeOptions = accountTypes.map(([label, value]) => 
      `<option value="${value}">${label}</option>`
    ).join('')

    const glAccountOptions = accountOptions.map(([text, value]) =>
      `<option value="${value}">${text}</option>`
    ).join('')

    return `
      <div class="flex items-center space-x-4 p-4 bg-gray-50 rounded-lg" data-target="key-account-assignments.assignment">
        <div class="flex-1">
          <label for="ledger_fund_key_account_assignments_attributes_${index}_account_type" class="block text-sm font-medium text-gray-700 mb-1">Account Type</label>
          <select name="ledger_fund[key_account_assignments_attributes][${index}][account_type]" 
                  id="ledger_fund_key_account_assignments_attributes_${index}_account_type"
                  class="form-control block pl-4 text-sm mt-2 placeholder-gray-400/70 rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-gray-700 focus:border-purple-400 focus:outline-none focus:ring focus:ring-purple-300 focus:ring-opacity-40">
            <option value="">Select account type</option>
            ${accountTypeOptions}
          </select>
        </div>
        
        <div class="flex-2">
          <label for="ledger_fund_key_account_assignments_attributes_${index}_gl_account_id" class="block text-sm font-medium text-gray-700 mb-1">GL Account</label>
          <div class="slimselect-wrapper">
            <select name="ledger_fund[key_account_assignments_attributes][${index}][gl_account_id]" 
                    id="ledger_fund_key_account_assignments_attributes_${index}_gl_account_id"
                    data-controller="table-row-select"
                    class="ss-main ss-single-selected med form-control block pl-4 text-sm mt-2 placeholder-gray-400/70 rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-gray-700 focus:border-purple-400 focus:outline-none focus:ring focus:ring-purple-300 focus:ring-opacity-40">
              <option value="">Select GL Account</option>
              ${glAccountOptions}
            </select>
          </div>
        </div>
        
        <div class="flex-shrink-0 pt-6">
          <button type="button" class="text-red-600 hover:text-red-800" data-action="click->key-account-assignments#removeAssignment">
            Remove
          </button>
        </div>
      </div>
    `
  }
}